<template>
  <app-page-container title="گزارش سفارشی">
    <template v-slot:header>
      <v-col cols="4" class="mr-n11">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3"></v-text-field>
      </v-col>
      <v-col cols="1" class="mr-n3">
        <v-btn class="mx-2 mt-3" fab dark small @click="showSearchModal()" color="darkColor" elevation="0">
          <v-icon dark>mdi-filter mdi-18px</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="1" class="mt-6" v-if="isSearch">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon light v-bind="attrs" v-on="on" @click="removeFilters()" class="mr-n3">
              mdi-filter-remove mdi-18px
            </v-icon>
          </template>
          <span>حذف فیلتر ها</span>
        </v-tooltip>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="1" class="mt-3">
        <v-btn @click="
          exportToExcel(
            customReportManagmentInformationTableHeaders,
            customReportPaginationList,
            'text',
            `custom_report_amar_page_${page}`,
          )
          " fab dark small color="darkColor" elevation="0">
          <v-icon dark>mdi-file-excel mdi-18px</v-icon>
        </v-btn>
      </v-col>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main">
        <v-col cols="12" class="pa-0 ma-0">
          <v-card elevation="0" class="body-card card-width pa-0 ma-0">
            <v-card-text class="pa-0 ma-0">
              <v-row no-gutters class="pa-0 ma-0">
                <v-col cols="12">
                  <template>
                    <v-data-table :headers="customReportManagmentInformationTableHeaders"
                      :items="customReportPaginationList" :page.sync="page"
                      :items-per-page="customReportPaginationList.length" height="70vh" :hide-default-footer="true"
                      multi-sort class="elevation-0 tt">
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1" color="iconColor" style="cursor: pointer"
                              @click="goToQcReportItems(item.id)" v-bind="attrs" v-on="on">
                              mdi-play-circle
                            </v-icon>
                          </template>
                          <span>نمایش</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:no-data>
                        <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                      </template>
                    </v-data-table>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <pagination-component ref="pagination">
            <div slot="action">
              <v-card elevation="0">
                <v-pagination class="mt-8" circle v-model="page" color="lightColor" :length="totalPages"
                  :total-visible="8" :value="totalPages" prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right"
                  @next="next()" @previous="previous()" @input="input()"></v-pagination>
              </v-card>
            </div>
          </pagination-component>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <section>
        <v-dialog width="450" v-model="searchModal">
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-magnify</v-icon>
                  <span class="modal-title-text mr-2">جستجو</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-12">
              <v-row>
                <v-col cols="12">
                  <v-text-field type="text" v-model="searchText" dense clearable clear-icon="mdi-close-circle-outline"
                    outlined v-on:keyup.enter="search()" label="عنوان" class="input-label"
                    prepend-inner-icon="mdi-text-box mdi-18px"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="search()" dark rounded class="normal-letter-spacing px-12">
                جستجو
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancelSearch()" class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </section>
      <section>
        <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
          :snakIcon="snakIcon"></alert-component>
      </section>
    </template>
  </app-page-container>
</template>
<script>
import AlertComponent from '@/components/AlertComponent.vue';
import AppPageContainer from '@/components/app/PageContainer.vue';
import PaginationComponent from '@/components/PaginationComponent.vue';
import ExcelHelper from '@/Helpers/Excel.generator.helper';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import pagination from '@/Mixins/Pagination';
import CustomReportMixin from '@/Mixins/Report/CustomReportMixin';
import CustomReportHelper from '@/Helpers/Report/QC/QcCustomReportHelper';
import '@/assets/styles/table.scss';
export default {
  name: 'QCCustomReport',
  title: 'گزارش سفارشی کنترل کیفیت',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    AlertComponent,
    PaginationComponent,
    AppPageContainer,
  },
  mixins: [
    pagination,
    ShearedMixin,
    CustomReportMixin,
    CustomReportHelper,
    snackBar,
    ShearedHelper,
    ExcelHelper,
  ],
  created() {
    this.$root.$refs.QCCustomReport = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      // this.$refs.pagination.newPageSize = 10;
      // this.$refs.pagination.pageSize = 10;
      this.getListOfCustomReportsWithPagination();
    },
    previous: function () {
      this.getListOfCustomReportsWithPagination();
      this.$refs.pagination.page = this.page;
    },
    next: function () {
      this.getListOfCustomReportsWithPagination();
      this.$refs.pagination.page = this.page;
    },
    input: function () {
      this.getListOfCustomReportsWithPagination();
      this.$refs.pagination.page = this.page;
    },
  },
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber {
  border: 2px solid #cdcbcf !important;
}

.card-add-phoneNumber-items {
  margin-top: -7px !important;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}

>>>.tt tbody tr:nth-of-type(even) {
  background-color: var(--background-color) !important;
}
</style>
